import { postAuthApi } from "../../webApis/apiResource";
import { webApiCheck } from "../../services/commonMethods";
import { LOGIN_SUCCESS, LOG_OUT } from "../../constants/action.constants";
import {
  setAccessToken,
  removeAccessToken,
  setUserDetails,
  setTokenExpiry,
  setUserPermissions,
} from "../../services/browserStorage";

export const requestLogin = (data) => {
  return async (dispatch) => {
    const response = await postAuthApi("/user-management", data);
    if (webApiCheck(response)) {
      const {
        data: { data, token, expires_at },
      } = response;
      setTokenExpiry(expires_at);
      setAccessToken(token);
      setUserDetails(data);
      setUserPermissions(data.Role.permissions);
      dispatch(loginSuccess());
    }
  };
};

export const loginSuccess = () => {
  return {
    type: LOGIN_SUCCESS,
  };
};

export const logOut = () => {
  removeAccessToken();
  localStorage.clear();
  return {
    type: LOG_OUT,
  };
};
